import { faJediOrder } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import './Price.css';

const WordPressDetails = ({data}) => {
    const {id, title,price, a, b, c, d, e, f, g, h, i, j, k, l, m, url} = data;
    return (
        <div className="col-md-4 p-3">
            <div className="serviceLi bg text-center text-white pt-3 pb-3">
            <h4 className="pb-3">{title}</h4>
             <div className="price">
             <span>${price}</span>
             </div>
                <div className="text-center mt-5">
                <ul> <li>{a}</li></ul>
                <ul> <li>{b}</li></ul>
                <ul> <li>{c}</li></ul>
                <ul> <li>{d}</li></ul>
                <ul> <li>{e}</li></ul>
                <ul> <li>{f}</li></ul>
                <ul> <li>{g}</li></ul>
                <ul> <li>{h}</li></ul>
                <ul> <li>{i}</li></ul>
                <ul> <li>{j}</li></ul>
                <ul> <li>{k}</li></ul>
                <ul> <li>{l}</li> </ul>
                <ul> <li>{m}</li> </ul>
                <button className="mt-5"><a href={url}>BUY</a></button>
                </div>
            </div>
         
        </div>
    );
};

export default WordPressDetails;